import { Avatar } from "@hightouch/htui";

import type { CommentAuthor } from "./comment-item";
import { ReviewAgentAvatar } from "./review-agent-avatar";

/**
 * Both kinds share a size at every step: they are the same circle on the same
 * scale, so any difference reads as a rendering bug rather than a distinction.
 * The icon inside carries the distinction instead.
 *
 * `sm` is the thread, its rail, and the activity list — where the 20px circle
 * also has to hold the column the status icons share. `lg` is the
 * notification feed.
 */
const SIZES = {
  sm: { user: "sm", agent: "sm" },
  md: { user: "md", agent: "md" },
  lg: { user: "lg", agent: "lg" },
} as const;

type Props = {
  author: CommentAuthor;
  size: keyof typeof SIZES;
};

/** Who wrote a comment, as a single avatar. */
export const CommentAuthorAvatar = ({ author, size }: Props) => {
  const { user, agent } = SIZES[size];

  if (author.kind !== "user") {
    return <ReviewAgentAvatar name={author.name} size={agent} />;
  }

  return <Avatar name={author.name} size={user} hideTooltip />;
};
